<i class="{{cell.class}}"></i>
